import { useParams, Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/base/Breadcrumb";
import EmptyState from "@/components/base/EmptyState";
import AnimeDetail from "./components/AnimeDetail";
import NewsDetail from "./components/NewsDetail";
import CharacterDetail from "./components/CharacterDetail";
import { usePageMeta } from "@/hooks/usePageMeta";
import { resolveContent } from "@/utils/content";
import { animeList } from "@/mocks/anime";
import { newsList } from "@/mocks/news";
import { characterList } from "@/mocks/characters";

export default function DetailPage() {
  const { id = "" } = useParams();
  const resolved = resolveContent(id);

  let breadcrumbLabel = "内容详情";
  let metaTitle = "内容详情 - 风车动漫网";
  let metaDescription = "浏览风车动漫网的内容详情。";
  if (resolved.type === "anime" && resolved.anime) {
    breadcrumbLabel = resolved.anime.title;
    metaTitle = `${resolved.anime.title} - 风车动漫网`;
    metaDescription = resolved.anime.description;
  } else if (resolved.type === "news" && resolved.news) {
    breadcrumbLabel = resolved.news.title;
    metaTitle = `${resolved.news.title} - 风车动漫网`;
    metaDescription = resolved.news.summary;
  } else if (resolved.type === "character" && resolved.character) {
    breadcrumbLabel = resolved.character.name;
    metaTitle = `${resolved.character.name} - 风车动漫网`;
    metaDescription = resolved.character.description;
  }

  usePageMeta({ title: metaTitle, description: metaDescription });

  if (resolved.type === null) {
    return (
      <Layout>
        <div className="mx-auto max-w-[1280px] px-4 py-16 md:px-6">
          <EmptyState
            icon="ri-error-warning-line"
            title="内容不存在或已删除"
            description="你访问的内容可能已下线，或链接有误。不妨返回首页，看看最新推荐的动画与资讯。"
            action={
              <Link
                to="/"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                返回首页
              </Link>
            }
          />
        </div>
      </Layout>
    );
  }

  let content = null;

  if (resolved.type === "anime" && resolved.anime) {
    const anime = resolved.anime;
    const related = animeList
      .filter((item) => item.id !== anime.id && item.genre.some((g) => anime.genre.includes(g)))
      .sort((a, b) => b.views - a.views)
      .slice(0, 4);
    content = <AnimeDetail anime={anime} related={related} />;
  } else if (resolved.type === "news" && resolved.news) {
    const news = resolved.news;
    const sameCategory = newsList.filter(
      (item) => item.id !== news.id && item.category === news.category,
    );
    const related = (
      sameCategory.length >= 2
        ? sameCategory
        : newsList.filter((item) => item.id !== news.id)
    )
      .sort((a, b) => b.views - a.views)
      .slice(0, 4);
    content = <NewsDetail news={news} related={related} />;
  } else if (resolved.type === "character" && resolved.character) {
    const character = resolved.character;
    const sameAnime = characterList.filter(
      (item) => item.id !== character.id && item.animeId === character.animeId,
    );
    const related = (
      sameAnime.length >= 2
        ? sameAnime
        : characterList.filter(
            (item) => item.id !== character.id && item.roleType === character.roleType,
          )
    )
      .sort((a, b) => b.views - a.views)
      .slice(0, 4);
    content = <CharacterDetail character={character} related={related} />;
  }

  return (
    <Layout>
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-[1280px] px-4 py-4 md:px-6">
          <Breadcrumb items={[{ label: breadcrumbLabel }]} />
        </div>
      </div>
      {content}
    </Layout>
  );
}